import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-vehicle-list',
  templateUrl: './vehicle-list.component.html',
  styleUrl: './vehicle-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VehicleListComponent {
  @Input() vehicleList;
  @Input() brand;
  @Input() logo: string;
  @Input() selectedType;
  @Input() viewAll;
  @Input() button1;
  @Input() button1Link;
  @Input() button2;

  showAllVehicles() {
    this.viewAll.value = !this.viewAll.value;
  }
  vehicleCta(destination) {
    window.open(destination, '_blank');
  }
}
